var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCall = function SvgIcCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.514 18.215a5.006 5.006 0 0 1-7.071 0l-5.657-5.657a4.97 4.97 0 0 1-1.464-3.536c0-1.335.52-2.591 1.464-3.536L7.78 3.492l2.357 3.3-.815.816a3.003 3.003 0 0 0 0 4.243l2.828 2.828c1.133 1.133 3.11 1.133 4.242 0l.816-.816 3.3 2.358-1.994 1.994Zm3.156-3.621-3.3-2.358a1.989 1.989 0 0 0-2.576.213l-.816.816a1.023 1.023 0 0 1-1.414 0l-2.828-2.828a1.002 1.002 0 0 1 0-1.415l.815-.815a1.995 1.995 0 0 0 .213-2.577l-2.357-3.3a1.998 1.998 0 0 0-1.462-.831 2.031 2.031 0 0 0-1.58.579L4.373 4.072a6.956 6.956 0 0 0-2.05 4.95c0 1.87.728 3.628 2.05 4.95l5.657 5.657a6.98 6.98 0 0 0 4.949 2.047 6.981 6.981 0 0 0 4.95-2.047l1.993-1.994c.417-.416.629-.992.58-1.58a1.994 1.994 0 0 0-.831-1.461Z",
    id: "ic_call_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic_call_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic_call_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic_call_svg__b)",
    fill: "#6B6C72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcCall;